import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Input, Popconfirm, Row, Select, Spin, Tooltip, Typography, Upload } from 'antd';
import React, { useEffect, useState } from 'react';
import { useStoreActions, useStoreState } from '../../../store/hooks/easyPeasy';

const { Option } = Select;

export default function DebatingClub() {
    const { Title } = Typography;
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState<any>([]);
    const [fileSave, setFileSave] = useState<boolean>(false);
    const [fileContent, setFileContent] = useState<any>('');
    const [fileType, setFileType] = useState<any>('');
    const [uploading, setUploading] = useState<boolean>(false);
    const [fileTypeChange, setFileTypeChange] = useState<any>();

    const [updateForm] = Form.useForm();
    const [updateFileList, setUpdateFileList] = useState<any>([]);
    const [updateFileContent, setUpdateFileContent] = useState<any>('');
    const [updateFileType, setUpdateFileType] = useState<any>('');
    const [updateUploading, setUpdateUploading] = useState<boolean>(false);
    const [updateFileTypeChange, setUpdateFileTypeChange] = useState<any>();

    const fetchCmsMiscellaneousInfo = useStoreActions((state) => state.pages.fetchCmsMiscellaneousInfo);
    const cmsMiscellaneousInfo = useStoreState((state) => state.pages.cmsMiscellaneousInfo);
    const saveDebatingClub = useStoreActions((state) => state.pages.saveDebatingClub);
    const deleteDebatingClubFile = useStoreActions((state) => state.pages.deleteDebatingClubFile);

    useEffect(() => { fetchCmsMiscellaneousInfo(); }, []);

    useEffect(() => {
        if (cmsMiscellaneousInfo?.debatingClubTitle) {
            updateForm.setFieldsValue({
                titleUpdate: cmsMiscellaneousInfo?.debatingClubTitle,
                descriptionUpdate: cmsMiscellaneousInfo?.debatingClubDescription,
            });
        }
    }, [cmsMiscellaneousInfo]);

    const onChangeFile = ({ fileList: newFileList }) => {
        if (newFileList.length === 1) {
            setUploading(true); newFileList[0].status = 'done'; setFileSave(true);
            setFileType(newFileList[0]?.name?.split('.').pop());
            const reader: any = new FileReader();
            reader.readAsDataURL(newFileList[0]?.originFileObj);
            setTimeout(() => { setFileContent(reader.result?.split(',')[1]); setUploading(false); }, 2000);
        }
        setFileList(newFileList);
    };
    const onChangeFileType = (value) => { setFileTypeChange(value); setFileContent(''); setFileType(''); setFileList([]); };

    const onChangeUpdateFile = ({ fileList: newList }) => {
        if (newList.length === 1) {
            setUpdateUploading(true); newList[0].status = 'done';
            setUpdateFileType(newList[0]?.name?.split('.').pop());
            const reader: any = new FileReader();
            reader.readAsDataURL(newList[0]?.originFileObj);
            setTimeout(() => { setUpdateFileContent(reader.result?.split(',')[1]); setUpdateUploading(false); }, 2000);
        }
        setUpdateFileList(newList);
    };
    const onChangeUpdateFileType = (value) => { setUpdateFileTypeChange(value); setUpdateFileContent(''); setUpdateFileType(''); setUpdateFileList([]); };

    const onSaveSubmit = (values) => {
        saveDebatingClub({ debatingClubTitle: values.title, debatingClubDescription: values.description, fileContent, fileSave, fileType });
        form.resetFields(); setFileList([]); setFileContent(''); setFileType(''); setFileSave(false); setFileTypeChange(undefined);
    };
    const onUpdateSubmit = (values) => {
        saveDebatingClub({ debatingClubTitle: values.titleUpdate, debatingClubDescription: values.descriptionUpdate, fileContent: updateFileContent, fileSave: updateFileContent !== '' ? true : false, fileType: updateFileType });
        setUpdateFileList([]); setUpdateFileContent(''); setUpdateFileType(''); setUpdateFileTypeChange(undefined);
    };

    const data = cmsMiscellaneousInfo;

    return (
        <>
            <Card title={<Title level={4} style={{ margin: 0 }}>Debating Club</Title>}>
                <Row gutter={[24, 24]}>
                    <Col xs={24} md={10}>
                        <Card type="inner" title="Debating Club Input" style={{ height: '100%' }}>
                            <Form layout="vertical" id="debatingClubSaveForm" form={form} onFinish={onSaveSubmit}>
                                <Form.Item name="title" label="Debating Club Title" className="title-Text" rules={[{ required: true, message: 'Please enter the title' }]}>
                                    <Input placeholder="Enter debating club title" />
                                </Form.Item>
                                <Form.Item name="description" label="Debating Club Description" className="title-Text" rules={[{ required: true, message: 'Please enter the description' }]}>
                                    <Input.TextArea rows={4} placeholder="Enter debating club description" />
                                </Form.Item>
                                <Form.Item name="fileType" label="Upload File Type" className="title-Text" rules={[{ required: true, message: 'Please select file type' }]}>
                                    <Select placeholder="Select File Type" onChange={onChangeFileType}>
                                        <Option value="Image">Image</Option>
                                        <Option value="File">File (PDF)</Option>
                                    </Select>
                                </Form.Item>
                                {fileTypeChange === 'Image' && (
                                    <Form.Item name="uploadFile" label="Photo" className="title-Text">
                                        <Spin tip="Uploading..." spinning={uploading}>
                                            <Upload listType="picture" accept="image/png, image/jpeg" fileList={fileList} onChange={onChangeFile}>{fileList.length < 1 && <Button icon={<UploadOutlined />}>Upload</Button>}</Upload>
                                        </Spin>
                                    </Form.Item>
                                )}
                                {fileTypeChange === 'File' && (
                                    <Form.Item name="uploadFile" label="File (PDF)" className="title-Text">
                                        <Spin tip="Uploading..." spinning={uploading}>
                                            <Upload listType="picture" accept="application/pdf,application/vnd.ms-word" fileList={fileList} onChange={onChangeFile}>{fileList.length < 1 && <Button icon={<UploadOutlined />}>Upload</Button>}</Upload>
                                        </Spin>
                                    </Form.Item>
                                )}
                                <Form.Item><Button type="primary" htmlType="submit" style={{ float: 'right' }}>Save</Button></Form.Item>
                            </Form>
                        </Card>
                    </Col>
                    <Col xs={24} md={14}>
                        <Card type="inner" title="Debating Club Output">
                            {data?.debatingClubTitle ? (
                                <>
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}><Typography.Text strong>Debating Club Title</Typography.Text><Input value={data?.debatingClubTitle} readOnly style={{ marginTop: 4 }} /></Col>
                                        <Col span={24}><Typography.Text strong>Debating Club Description</Typography.Text><Input.TextArea value={data?.debatingClubDescription} readOnly rows={3} style={{ marginTop: 4 }} /></Col>
                                        {data?.debatingClubFileName && (
                                            <Col span={24}>
                                                <Typography.Text strong>Debating Club File</Typography.Text>
                                                <div style={{ marginTop: 8 }}>
                                                    {data?.debatingClubFileViewerLink?.match(/\.(jpg|jpeg|png|gif)$/i)
                                                        ? <img src={data?.debatingClubFileViewerLink} alt="Debating Club" style={{ maxWidth: '100%', maxHeight: 200, objectFit: 'contain', border: '1px solid #d9d9d9', borderRadius: 4, display: 'block' }} />
                                                        : <a href={data?.debatingClubFileLink} target="_blank" rel="noreferrer">{data?.debatingClubFileName}</a>}
                                                    <Popconfirm title="Are you sure you want to delete this file?" okText="Yes" cancelText="No" onConfirm={() => deleteDebatingClubFile({})}>
                                                        <Tooltip title="Delete File"><Button danger icon={<DeleteOutlined />} style={{ marginTop: 8, float: 'right' }}>Delete File</Button></Tooltip>
                                                    </Popconfirm>
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                    <hr style={{ margin: '20px 0', borderColor: '#f0f0f0' }} />
                                    <Form layout="vertical" id="debatingClubUpdateForm" form={updateForm} onFinish={onUpdateSubmit}>
                                        <Row gutter={[16, 0]}>
                                            <Col span={24}><Form.Item name="titleUpdate" label="Debating Club Title" className="title-Text" rules={[{ required: true, message: 'Please enter the title' }]}><Input placeholder="Enter debating club title" /></Form.Item></Col>
                                            <Col span={24}><Form.Item name="descriptionUpdate" label="Debating Club Description" className="title-Text" rules={[{ required: true, message: 'Please enter description' }]}><Input.TextArea rows={3} placeholder="Enter description" /></Form.Item></Col>
                                            <Col span={24}><Form.Item name="updateFileType" label="Upload File Type" className="title-Text"><Select placeholder="Select File Type" onChange={onChangeUpdateFileType}><Option value="Image">Image</Option><Option value="File">File (PDF)</Option></Select></Form.Item></Col>
                                            {updateFileTypeChange === 'Image' && <Col span={24}><Form.Item name="updateUploadFile" label="Photo" className="title-Text"><Spin tip="Uploading..." spinning={updateUploading}><Upload listType="picture" accept="image/png, image/jpeg" fileList={updateFileList} onChange={onChangeUpdateFile}>{updateFileList.length < 1 && <Button icon={<UploadOutlined />}>Upload</Button>}</Upload></Spin></Form.Item></Col>}
                                            {updateFileTypeChange === 'File' && <Col span={24}><Form.Item name="updateUploadFile" label="File (PDF)" className="title-Text"><Spin tip="Uploading..." spinning={updateUploading}><Upload listType="picture" accept="application/pdf,application/vnd.ms-word" fileList={updateFileList} onChange={onChangeUpdateFile}>{updateFileList.length < 1 && <Button icon={<UploadOutlined />}>Upload</Button>}</Upload></Spin></Form.Item></Col>}
                                            <Col span={24}><Button type="primary" htmlType="submit" style={{ float: 'right' }}>Update</Button></Col>
                                        </Row>
                                    </Form>
                                </>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '40px 0', color: '#aaa' }}>No debating club data found. Use the Save form to create one.</div>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Card>
        </>
    );
}
